import React, { useEffect, useState } from 'react';

// Style
import './LibrariesProduct.scss';
import 'pages/Main/SectionHighlight.scss';

// Clsx
import clsx from 'clsx';

// Lib
import Cookies from 'js-cookie';
import { sanitize } from 'dompurify';
import { useWindowSize } from 'lib/hooks';
import { shallowEqual } from 'react-redux';
import { amplitudeInstance, events } from 'constans/cookie';
import { useRegisterTutorialKey } from 'lib/hooks/useTutorial';
import { decodeHtmlEntity, filteredDataByKey } from 'lib/helpers';
import { useAppDispatch, useAppSelector } from 'lib/hooks/useDispatch';

// UrlParam
import { useLocation, useNavigate, useParams } from 'react-router-dom';

// Components
import List from './components/List';
import Offer from './components/Offer';
import Download from './components/Download';
import EmptyData from './components/EmptyData';
import ScrollButton from 'components/ScrollButton';
import Description from './components/Description';
import ErrorBoundary from 'components/ErrorBoundary';
import SliderComponent from 'components/SliderComponent';

// Actions
import * as actionCreators from './reducer';

// Images
import NavigationBack from 'components/NavigationBack';

export const LibrariesProduct: React.FC = () => {
	const urlParam = useParams();
	const navigate = useNavigate();
	const { state } = useLocation();
	const registerTutorialKey = useRegisterTutorialKey();
	const dispatch = useAppDispatch();

	const isCart = state?.isCart || false;
	const { id } = urlParam;

	const {
		lib,
		message,
		highlightData
	} = useAppSelector(
		(store) => {
			return {
				message: store.librariesProduct.message,
				highlightData: store.librariesProduct?.highlightData,
				lib: store.librariesProduct?.libDetailsData?.lib || {}
			};
		},
		shallowEqual
	);

	const [widthCarousel, setWidthCarousel] = useState<number>(0);

	// Scroll to top after navigating
	useEffect(() => {
		window.scrollTo(0, 0);
	}, [navigate]);

	useEffect(() => {
		registerTutorialKey('bioactive-libraries', () => !!Object.values(lib)?.length, "normal", "general");
	}, [lib]);

	useEffect(() => () => {
		dispatch(actionCreators.clearMessage());
	}, []);

	useEffect(() => {
		const isCookie = Cookies.get('cookieName');

		if (lib?.catNumber && isCookie) {
			amplitudeInstance.logEvent(events.library, { id: lib?.catNumber });
		}

		const htmlWrapperSmallSlider = document.querySelector('.section-high-light__content');

		if (htmlWrapperSmallSlider) {
			setWidthCarousel(htmlWrapperSmallSlider?.clientWidth);
		}
	}, [lib?.catNumber]);

	useEffect(() => {
		if (!!id) {
			dispatch(actionCreators.getHighlightLib(id));
			dispatch(actionCreators.getLibrariesFullDetails(id));
		}
	}, [id]);

	const handlerClickCart = (cartId: string) => {
		window.location.href = `${window.location.origin}/molecule-product/${cartId}`;
	};

	const isDesktop = useWindowSize().width <= 1024;
	const fileTypes = lib?.fileTypes || [];
	const imgCenter = filteredDataByKey({ data: fileTypes, key: 'IMG_CENTER' });

	const cn = clsx(
		'libraries-description',
		!!imgCenter?.length ? 'libraries-description--active' : ''
	);

	const cnHeader = clsx(
		!!imgCenter?.length
			? ''
			: 'libraries-description__header flex flex-ai-center flex-direction-column mb30'
	);

	if (message === 'You\'re not allowed to get this library') {
		return <EmptyData />;
	}

	const url = isCart ? '/search' : '/libraries';
	const settings = {
		isArrows: true,
		slidesToShow: 4,
		centerMode: false,
		width: widthCarousel,
		lengthArray: highlightData?.length,
		infinite: ((highlightData?.length || 0) > 3),
		className: 'section-high-light__wrapper-hightlight'
	};

	return (
		<ErrorBoundary>
			<>
				<div className={cn}>
					<ScrollButton />
					<div className="wrapper relative">
						<NavigationBack
							url={url}
							label="Back"
							className="screen-libraries-product__back"
						/>

						<div className={cnHeader}>
							<div className="libraries-description__text text-align-cn">
								{!!lib?.catNumber && <p className="libraries-description__cat-number">{lib?.catNumber || ''}</p>}

								<h1
									className="libraries-description__title mb10"
									dangerouslySetInnerHTML={{ __html: sanitize(decodeHtmlEntity(lib?.name || '') || '') }}
								/>
							</div>
							{!!lib?.catNumber && <Download />}
						</div>

						<Description />
					</div>
				</div>

				{!!highlightData?.length && <SliderComponent
					title="Highlights"
					isMobile={isDesktop}
					settings={settings}
					data={highlightData}
					handlerClick={handlerClickCart}
					className="section-high-light__hight section-high-light__wrapper relative mb30"
				/>}

				<Offer />
				<List />
			</>
		</ErrorBoundary>
	);
};

export default LibrariesProduct;